import { inject, Injectable } from "@angular/core";
import { DialogService } from "./dialog.service";
import { HTTPService } from "./http.service";
import { UploadServices } from "./upload.services";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { SnackbarService } from "./snackbar.service";
import { FieldConfiguration, FileLoaderComponent } from "../system-utils/file-loader/file-loader.component";
import { FormulaServices } from "./formula.service";
import { Variable } from "../forms/formula-tester/formula-tester.component";

@Injectable()
export class FileLoaderServices {
    sub: Subscription;

    constructor(private snackBar:SnackbarService, private http:HTTPService, private dialog:DialogService,
      private fs:FormulaServices
    ){}

    progress: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private updLoad:UploadServices = inject(UploadServices);

    loadFileOpener(raw,parameter){
        this.dialog.openGenericDialog(FileLoaderComponent,JSON.parse(parameter),(data)=>{},()=>{},
        '80vh','80vw',true,null,'S','80px');
    }

    saveFileServices(
            entityName:string, 
            blobField:string,
            data:FieldConfiguration[],
            condicao:string,
            pk:string[],
            objectParam:object,
            fileType:string,
            fileName:string,
            expirationDate:string,
            saveBlob:boolean,
            blob:Blob){

        return new Promise(async (resolve,reject)=>{
            let ob = {
              entityName:entityName 
            }
            try{
              for (var key of data ){
                
                let value = key.value;
                let name = key.name;
                
                
                if ( key.type == 'G'){
  
                  let variables:Variable[] = [];
                  Object.keys(objectParam).forEach((key1)=>{
                    let param:Variable = {
                      key: key1.replace("{","").replace("}",""),
                      value: String(objectParam[key1]),
                      type:'TEXTO'
                    }
                    variables.push(param);
                  });
                  variables.push({
                    key: "@FILENAME",
                    value: fileName,
                    type:"TEXTO"
                  });
                  variables.push({
                    key: "@FILETYPE", 
                    value: fileType,
                    type:"TEXTO"
                  });
                  variables.push({
                    key: "@FILETEXT", 
                    value: await this.convertBlobToText(blob).then((d)=>{return d;}).catch((e)=>{throw e}),
                    type:"XML"
                  });
                  variables.push({
                    key: "@EXPIRATIONDATE", 
                    value: expirationDate,
                    type:"TEXTO"
                  });
                  
                  await this.fs.executeFormula(value,variables).then((resultado)=>{
                    ob[name] = resultado;
                  }).catch((e)=>{
                    throw e;
                  });

                }else{
                  if ( value == "{@FILENAME}"){
                    ob[name] = fileName;
                }else
                if ( value == "{@FILETYPE}"){
                  ob[name] = fileType;
                }else
                if ( value == "{@FILETEXT}"){
                  ob[name] = await this.convertBlobToText(blob).then((d)=>{
                    return d;
                  }).catch((e)=>{
                    throw e
                  });
                }else
                if ( value == "{@EXPIRATIONDATE}"){
                    ob[name] = expirationDate;
                }else{
                  if ( objectParam != null && objectParam[value] != null ){
                    ob[name] = this.convertToType(objectParam[value],key.type);
                  }else
                    ob[name] = this.convertToType(value,key.type);
                  }                
                }
                 
              }
              
            }catch(exception){
              reject(exception);
              return;
            }
            
            
            this.sub = this.http.post(ob,'JsonBrokerServices/save',false,true,false).subscribe({
                next:async (retorno)=>{
                    if (retorno == null || retorno == undefined){
                        this.snackBar.showError('fileupload.errorsavingfile');
                        return;
                    } 
                    let resolveObject = {
                        entityName:entityName,
                    };

                    pk.forEach((key)=>{
                        if ( retorno[key] == undefined || retorno[key] == null ){ 
                            this.snackBar.showError('fileupload.errorsavingfile');
                            return;
                        }
                        resolveObject[key] = retorno[key];
                    });

                    let regex = new RegExp(/{@(.*?)}/g);
                    var match;
                    
                    while ((match = regex.exec(condicao)) !== null) {
                      let variable:string = match[0];
                      let workVariable:string =  variable.replace("{@", "").replace("}", "").toUpperCase();
                      if ( resolveObject[workVariable] ){
                        let toReplace = resolveObject[workVariable];
                        condicao = condicao.replace(variable,toReplace);
                      }
                    }
                    if ( saveBlob ){
                        await this.callUploadService(blob,entityName,blobField,condicao).then(d=>{
                          resolve(resolveObject);
                        }).catch(e=>{
                          reject(e);
                        });
                    }else{
                      resolve(resolveObject);
                    }
                    
                    
                },
                error:(error)=>{
                  reject(error)
                }
            });
        });
    }

  
  convertToType(value: any, type: string ): any {
    if ( type == "S" || type == "D" ){
      return value;
    }else{
      if ( type == "F" || type == "N" ){	
        return parseFloat(value);
      }else{
        if ( type == "I" ){
          return parseInt(value);
        }
      }
    }
  }
  convertBlobToText(blob: Blob): any {
    
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsText(blob);
        });

  }


    cancelUpload() {
        if ( this.sub != null ){
            this.sub.unsubscribe();
        }
        
        if ( this.progress != null ){
          this.progress.unsubscribe();
        }
        this.reset();
    }
    
    reset() {
        this.progress =null;
        this.sub = null;
    }

    callUploadService(file:Blob, entityName:string, columnName:string, condicao:string) {  
  
        return new Promise((resolve,reject)=>{
          const formData = new FormData();  
          formData.append('file', file, 'image');  
          let ob = {
              entityName: entityName,
              datafield: columnName,
              condition: condicao
          }
          
          formData.append('data',JSON.stringify(ob));
        
          
          this.updLoad.progress.subscribe(number=>{
            if ( this.progress == null ){
              this.progress = new BehaviorSubject<number>(0);
            }
            this.progress.next(number);
            
          });
     
          
          this.updLoad.upLoadFile(formData, true).subscribe({
          
            complete:()=>{
              resolve(true);
              //this.updLoad.progress.next(0);
            },
            error:(error)=>{
              reject(error);
            }
          });    
        
        });
    }

    private fileLoadedSource = new Subject<string>();
    fileLoaded$ = this.fileLoadedSource.asObservable();

    readFile(file: File): void {
      
      const reader = new FileReader();

      reader.onload = () => {
        const content = reader.result as string;
        this.fileLoadedSource.next(content); // ✅ Emit to subscribers

      };

      reader.onerror = () => {
        this.fileLoadedSource.error(reader.error); // Optional: emit error

      };

      reader.readAsText(file);
    }

}